import { isAfter } from 'date-fns';
import type z from 'zod';

import type { JWTTokenSchema } from './jwt.schema';

export class JWTDomain {
  public static isTokenPayloadExpired(payload: z.infer<typeof JWTTokenSchema>) {
    return isAfter(new Date(), JWTDomain.expiresAt(payload));
  }

  public static createdAt(payload: z.infer<typeof JWTTokenSchema>) {
    return new Date(payload.iat * 1000);
  }

  public static expiresAt(payload: z.infer<typeof JWTTokenSchema>) {
    return new Date(payload.exp * 1000);
  }
}
